import { MarginMap } from "#internal"
import type { Margins } from "#public"

import { Max, Min, POS_INFINITY } from "../math/Math"

/** Margins with every edge raised to at least its `floor` edge and cut down to
 * at most its `ceiling` one — by default nothing below and no cap above: an
 * inner box poking out of the outer one leaves no room on that side. */
export const ClampMargins = <T extends number>(
  margins: Margins<T>,
  floor: T | Margins<T> = 0 as T,
  ceiling: T | Margins<T> = POS_INFINITY as T
): Margins<T> => MarginMap((value, min, max) => Min(max, Max(min, value)), margins, floor, ceiling)
